import { Injectable } from '@angular/core';
import { Mouse, MouseState } from '.';
import { CallbackSet } from '../execution';
import { Bounds } from '../spatial';
import { Set } from '../collections';
import { Str, Obj } from '../utils';
export class MouseService {
private _bounds: Set<Bounds>;
private _mouse: Mouse;
private _isListening: boolean;
private _callbacks: CallbackSet;
private _state: MouseState;
private _press: MouseState;
private _stateTimer: any;
constructor() { 
    this._isListening = false;
    this._mouse = new Mouse();
    this._callbacks = new CallbackSet();
    this._bounds = new Set<Bounds>();
    this._state = MouseState.Still;
    this._press = MouseState.Up;
  }
/**
 * @param {?} name
 * @param {?} x
 * @param {?} y
 * @param {?} width
 * @param {?} height
 * @return {?}
 */
public setBounds(name: string, x: number, y: number, width: number, height: number): void {
    if(Str.isEmptyString(name)) {
      throw Error('Name is null or undefined');
    }
    this._bounds.add(name, new Bounds(x, y, width, height));
  }
/**
 * @param {?} name
 * @return {?}
 */
public isWithinBounds(name: string): boolean {
    if(Str.isEmptyString(name)) {
      throw Error('Name is null or undefined');
    }
    let /** @type {?} */ bounds = this._bounds.first(name);
    if(Obj.isNullOrUndefined(bounds)) {
      throw Error('Bounds are null or undefined');
    }
    return bounds.isWithin(this._mouse.x, this._mouse.y);
  }
/**
 * @param {?=} toListen
 * @return {?}
 */
public listen(toListen?: boolean): void {
    // defaults to true if not passed
    this._isListening = toListen === false ? false : true;

    if(this._isListening === false) {
      // remove event listeners
      document.removeEventListener('mousemove');
    } else {

      // add event listeners
      document.addEventListener('mousemove', (event: MouseEvent) => {
        this._mouse.x = event.pageX;
        this._mouse.y = event.pageY;

        this._state = MouseState.Moving;
        clearTimeout(this._stateTimer);
        this._stateTimer = setTimeout(() => {
          this._state = MouseState.Still;

        }, 100);
        
        if(this._callbacks.hasValue('mousemove')) {
          this._callbacks.each('mousemove', (handler: Function, i: number) => {
            handler(event);
          });
        }
      });

      document.addEventListener('click', (event: MouseEvent) => {
        if(this._callbacks.hasValue('click')) {
          this._callbacks.each('click', (handler: Function, i: number) => {
            handler(event);
          });
        }
      });

      document.addEventListener('mousedown', (event: MouseEvent) => {
        this._press = MouseState.Down;
        if(this._callbacks.hasValue('mousedown')) {
          this._callbacks.each('mousedown', (handler: Function, i: number) => {
            handler(event);
          });
        }
      });

      document.addEventListener('mouseup', (event: MouseEvent) => {
        this._press = MouseState.Up;
        if(this._callbacks.hasValue('mouseup')) {
          this._callbacks.each('mouseup', (handler: Function, i: number) => {
            handler(event);
          });
        }
      });
    }
  }
/**
 * @return {?}
 */
public getState(): MouseState {
    return this._state;
  }
/**
 * @param {?} callback
 * @return {?}
 */
public onClick(callback: Function): void {
    this._callbacks.add('click', callback);
  }
/**
 * @param {?} callback
 * @return {?}
 */
public onMousemove(callback: Function): void {
    this._callbacks.add('mousemove', callback);
  }
/**
 * @param {?} callback
 * @return {?}
 */
public onMousedown(callback: Function): void {
    this._callbacks.add('mousedown', callback);
  }
/**
 * @param {?} callback
 * @return {?}
 */
public onMouseup(callback: Function): void {
    this._callbacks.add('mouseup', callback);
  }
/**
 * @return {?}
 */
public getMouse(): Mouse {
    return this._mouse;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MouseService_tsickle_Closure_declarations() {
/** @type {?} */
MouseService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MouseService.ctorParameters;
/** @type {?} */
MouseService.prototype._bounds;
/** @type {?} */
MouseService.prototype._mouse;
/** @type {?} */
MouseService.prototype._isListening;
/** @type {?} */
MouseService.prototype._callbacks;
/** @type {?} */
MouseService.prototype._state;
/** @type {?} */
MouseService.prototype._press;
/** @type {?} */
MouseService.prototype._stateTimer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
